import React from "react";
import axios from "axios";
import {
  BiTargetLock,
  BiHourglass,
  BiMobileAlt,
  BiMoney,
  BiClinic,
  BiUser,
} from "react-icons/bi";
import "./styles.css"; //import CSS file for styling
import productImage from "../../../assets/panel-scobo-en.png"; //import product image
import FooterEn from "../footer-en";
import HeaderEn from "../header-en";

class HomePageEn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sendMessage: "Hello,I'mInHomePageEn",
      subPage: 0,
      testsCount: 0,
      clinicsCount: 0,
    };
  }

  componentDidMount = async () => {
    this.handleRedirect();
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
    this.setState({ testsCount: response.data.tests });
    this.setState({ clinicsCount: response.data.clinics });
  }

  render() {
    return (
      <div className="container-v1">
        <HeaderEn />
        <div className="mode-bg-9 d-ltr" style={{ backgroundColor: "#F8F9FD" }}>
          <div className="landing-container">
            <div className="product-wrapper-left d-ltr justify-content-center align-items-start">
              <h1 className="landing-heading">AI-Powered</h1>
              <h1 className="landing-heading">Autism Screening</h1>
              <h1 className="landing-heading">made Simple</h1>
              <p className="landing-text mt-4">
                We believe you can control autism if you diagnose it in early
                stages. If it matters to you as a parent, take 5 minutes to fill
                a questionnaire and get an instant response by AI.
              </p>
              {/* <button className="cta-button" onClick={this.submitHandler}>Get Started</button> */}
              <a
                href="/en/products/autism-screening-ticket"
                className="cta-button d-flex align-items-center"
                style={{ width: "220px", height: "40px", margin: 0 }}
              >
                Get Started
              </a>
            </div>

            <div className="product-wrapper-right">
              <img
                src={productImage}
                alt="Product Image"
                className="product-image"
              />
            </div>
          </div>

          <div className="landing-description mt-5 mb-3 align-items-center">
            <div className="d-flex flex-column justify-content-center align-items-center align-text-center w-80">
              <h2>{"Why AI-Powered Autism Screening?"}</h2>
              <p>
                {
                  "Our revolutionary AI-powered autism screening offers rapid, precise assessments for children under 3. It's free, user-friendly, and accessible on mobile. Invest just 5 minutes for a stress-free evaluation, ensuring a brighter future for your child."
                }
              </p>
            </div>

            <div className="landing-description-body">
              <div className="landing-description-body-row">
                <div className="landing-description-body-row-section">
                  <div className="w-20 font-64">
                    <BiTargetLock />
                  </div>
                  <div className="d-flex flex-column w-80">
                    <h3>{"High Precision"}</h3>
                    <p>
                      {
                        "Our AI questionnaire is honed by +1000 real-world toddler data — autistic and non-autistic — validated by clinicians. It stands as one of the world's most precise tools, offering you confidence in early autism detection and informed decision-making—all without any charge."
                      }
                    </p>
                  </div>
                </div>
                <div className="landing-description-body-row-section">
                  <div className="w-20 font-64">
                    <BiHourglass />
                  </div>
                  <div className="d-flex flex-column w-80">
                    <h3>{"It's Early"}</h3>
                    <p>
                      {
                        "Identifying autism before age 3 is crucial. Our free and user-friendly screening empowers proactive parents to take timely actions, potentially mitigating lifelong consequences. Screen whenever you want, without stress, and in the comfort of your personal space."
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="landing-description-body-row">
                <div className="landing-description-body-row-section">
                  <div className="w-20 font-64">
                    <BiMobileAlt />
                  </div>
                  <div className="d-flex flex-column w-80">
                    <h3>{"Simple to Use"}</h3>
                    <p>
                      {
                        "Our screening is designed for simplicity. Available on mobile devices, you can assess your child's development at your convenience, free from judgment. No costs, no stress—just a quick, accessible tool for every parent concerned about their child's well-being."
                      }
                    </p>
                  </div>
                </div>
                <div className="landing-description-body-row-section">
                  <div className="w-20 font-64">
                    <BiMoney />
                  </div>
                  <div className="d-flex flex-column w-80">
                    <h3>{"It's Free"}</h3>
                    <p>
                      {
                        "Our AI-powered screening tool is completely free—no hidden fees or subscriptions. Use it as often as needed without any financial burden. It's our commitment to making early autism screening accessible and affordable for every parent."
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="landing-statistics mt-5 mb-3 align-items-center">
            <div className="d-flex flex-column justify-content-center align-items-center align-text-center w-80">
              <h2>{"Trusted by great people"}</h2>
              <p>
                {
                  "Join our parents and clinics who trust our AI-powered screening. Elevate your child's future with confidence. Your journey to peace of mind starts here."
                }
              </p>
            </div>

            <div className="landing-description-body">
              <div className="landing-description-body-row">
                <div className="landing-statistics-section">
                  <div className="d-flex justify-content-center font-128">
                    <BiClinic />
                  </div>
                  <h1 className="d-flex justify-content-center mt-0 mb-0 font-54">
                    {this.state.clinicsCount}
                  </h1>
                </div>
                <div className="landing-statistics-section">
                  <div className="d-flex justify-content-center font-128">
                    <BiUser />
                  </div>
                  <h1 className="d-flex justify-content-center mt-0 mb-0 font-54">
                    {this.state.testsCount}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterEn />
      </div>
    );
  }
}

export default HomePageEn;
